import {NavLink} from 'react-router-dom';
import React from "react";

const Menu = () => {
    const userType = localStorage.getItem("userType");
      return (
        <nav>
            <h1> VisitLog German Genetic </h1>
            {/*<NavLink to="/notizen" end> Notizen </NavLink>*/}

            { userType === "ADMIN" && <NavLink to="/dashboard"> Dashboard </NavLink> }
            <NavLink to="/farmers"> Landwirte </NavLink>
            <NavLink to="/calender"> Kalender </NavLink>
            <NavLink to="/multiplikatoren"> MuPli </NavLink>
            <NavLink to="/logout"> Abmelden </NavLink>
        </nav>
      );
};

export default Menu;
